<template>
    <div v-if="is_discount_loaded">
        test
        <b-modal
            v-model="_show_modal_local"
            :title="'Редактирование скидки №'+ discount.id"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <div class="row">
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Доступность скидки"
                    >
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="enabled"
                                value="1"
                                v-model="_enabled">
                            <label class="custom-control-label" for="enabled">скидка доступна при оформлении путевок</label>
                        </div>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Наименование скидки"
                        description="Здесь должен быть только текст, не более 100 символов"
                        :invalid-feedback="veeErrors.first('title')"
                    >
                        <input class="form-control" type="text" v-model="discount.title"
                               v-validate="{ required:true,max:100 }" name="title"  data-vv-as="'Наименование скидки'">

                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        description=" Скидка расчитывается либо как %, либо как фиксированная сумма, либо как стоимость количества дней (т.е. например при бронировании 7-ми дней 1 день в подарок, т.е. оплата пойдет за 6 дней). Если применение скидки изменяет % вознаграждения объекта - укажите и его"
                    ></b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-3">
                    <b-form-group
                        label="% скидки"
                        description=""
                        :invalid-feedback="veeErrors.first('value_percent')"
                    >
                        <input class="form-control" type="text" v-model="discount.value_percent" @change="onChangePercent"
                               v-validate="{ integer:true,min_value:0,max_value:100 }" name="value_percent"  data-vv-as="'% скидки'">
                    </b-form-group>
                </div>
                <div class="col col-3">
                    <b-form-group
                        label="фиксированная сумма"
                        description=""
                        :invalid-feedback="veeErrors.first('value_fixed')"
                    >
                        <input class="form-control" type="text" v-model="_value_fixed" @change="onChangeFixed"
                               v-validate="{ decimal:2,min_value:0 }" name="value_fixed"  data-vv-as="'фиксированная сумма'">
                    </b-form-group>
                </div>
                <div class="col col-3">
                    <b-form-group
                        label="кол-во дней"
                        description=""
                        :invalid-feedback="veeErrors.first('value_days')"
                    >
                        <input class="form-control" type="text" v-model="discount.value_days" @change="onChangeDays"
                               v-validate="{ integer:true,min_value:0 }" name="value_days" data-vv-as="'кол-во дней'">
                    </b-form-group>
                </div>
                <div class="col col-3">
                    <b-form-group
                        label="% вознаграждения"
                        description=""
                        :invalid-feedback="veeErrors.first('hotel_fee')"
                    >
                        <input class="form-control" type="text" v-model="discount.hotel_fee"
                               v-validate="{ integer:true,min_value:0,max_value:100 }" name="hotel_fee"  data-vv-as="'% вознаграждения'">
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        description="Укажите номер и/или программу для которых действует скидка. Если ничего не выбрано , то скидка распространяется на все предложения объекта."
                    ></b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Номер"
                    >
                        <select class="form-control" v-model="discount.room_id">
                            <option v-for="room in rooms" v-bind:key="room.id" v-bind:value="room.id" >{{room.title}}</option>
                        </select>
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Программа"
                    >
                        <select class="form-control" v-model="discount.tarif_id">
                            <option v-for="program in programs" v-bind:key="program.id" v-bind:value="program.id" >{{program.title}}</option>
                        </select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        description='Скидка предоставляется если была продана в интервале от "Начало заездов" до "Конец заездов" включительно и период бронирования попадает
                    в интервал от "Начало продаж" до "Конец продаж" включительно. Если какая-то из дат не задана, то соответствующее ограничение не учитывается.
                    Если даты не заданы то значит скидки действуют без какого-либо вркеменного ограничения.'
                    ></b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-6 col-lg-3">
                    <b-form-group
                        label="Начало продаж"
                    >
                        <v-date-picker
                            v-model='_sale_start_at'
                            id="sale_start_at"
                            name="sale_start_at"
                            data-vv-as="'Начало продаж'"
                            :state="validateState('sale_start_at')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="sale_start_at_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
                <div class="col col-6 col-lg-3">
                    <b-form-group
                        label="Конец продаж"

                    >
                        <v-date-picker
                            v-model='_sale_end_at'
                            id="sale_end_at"
                            name="sale_end_at"
                            data-vv-as="'Конец продаж'"
                            :state="validateState('sale_end_at')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="sale_end_at_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>

                </div>
                <div class="col col-6 col-lg-3">
                    <b-form-group
                        label="Начало заездов"
                    >
                        <v-date-picker
                            v-model='_start_at'
                            id="start_at"
                            name="start_at"
                            data-vv-as="'Начало заездов'"
                            :state="validateState('start_at')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="start_at_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
                <div class="col col-6 col-lg-3">

                    <b-form-group
                        label="Конец заездов"
                    >
                        <v-date-picker
                            v-model='_end_at'
                            id="end_at"
                            name="end_at"
                            data-vv-as="'Конец заездов'"
                            :state="validateState('end_at')"
                            :attributes="datepicker_attributes"
                            :min-date='new Date()'
                        >
                            <input
                                id="end_at_input"
                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                class="form-control form-date-picker"
                                readonly
                                v-bind="inputProps"
                                v-on="inputEvents"
                            />
                        </v-date-picker>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Минимальное количество дней"
                        description="Укажите минимальное количество дней путевки, необходимое что бы скидка учлась. Если значение = 0 то условие не действует."
                        :invalid-feedback="veeErrors.first('minimal_range')"
                    >
                        <input class="form-control" type="text" v-model="discount.minimal_range"
                               v-validate="{ integer:true,min_value:0,max_value:1000 }" name="minimal_range"  data-vv-as="'Минимальное количество дней'">
                    </b-form-group>
                </div>
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Срок раннего бронирования"
                        description="Укажите минимальное количество дней от даты бронирования до даты заезда, необходимое что бы скидка учлась.  Если значение = 0 то условие не действует."
                        :invalid-feedback="veeErrors.first('early_booking')"
                    >
                        <input class="form-control" type="text" v-model="discount.early_booking"
                               v-validate="{ integer:true,min_value:0,max_value:1000 }" name="early_booking"  data-vv-as="'Срок раннего бронирования'">
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Минимальный возраст"
                        description="Укажите минимальный возраст, начиная с которого (включительно) действует скидка. Если не применяется оставьте поле пустым."
                        :invalid-feedback="veeErrors.first('age_from')"
                    >
                        <input class="form-control" type="text" v-model="discount.age_from"
                               v-validate="{ integer:true,min_value:0,max_value:100 }" name="age_from"  data-vv-as="'Минимальный возраст'">
                    </b-form-group>
                </div>
                <div class="col col-12 col-lg-6">

                    <b-form-group
                        label="Максимальный возраст"
                        description="Укажите максимальный возраст, до которого (включительно) действует скидка. Если не применяется оставьте поле пустым."
                        :invalid-feedback="veeErrors.first('age_to')"
                    >
                        <input class="form-control" type="text" v-model="discount.age_to"
                               v-validate="{ integer:true,min_value:0,max_value:100 }" name="age_to"  data-vv-as="'Максимальный возраст'">
                    </b-form-group>
                </div>
                <div class="col col-12 col-lg-6">

                    <b-form-group
                        label="Тип заселения"
                        description="Укажите тип заселения для которого применяется скидка."
                    >
                        <select class="form-control" v-model="discount.place_type">
                            <option value="0">Все места</option>
                            <option value="1">Основные места</option>
                            <option value="2">Дополнительные места</option>
                            <option value="3">Одноместное заселение</option>
                        </select>
                    </b-form-group>

                </div>
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Пол"
                        description="Укажите пол отдыхающего для которого применяется скидка."
                    >
                        <select class="form-control" v-model="discount.sex">
                            <option value="">Все</option>
                            <option value="M">Мужчины</option>
                            <option value="F">Женщины</option>
                        </select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Социальная скидка"
                    >
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="social"
                                value="1"
                                v-model="_social">
                            <label class="custom-control-label" for="social">Скидка применяется только к туристам у которых отмечено применять социальную скидку</label>
                        </div>
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Не комбинировать"
                    >
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="no_combine"
                                value="1"
                                v-model="_no_combine">
                            <label class="custom-control-label" for="no_combine">Скидка не комбинируется с другими скидками</label>
                        </div>
                    </b-form-group>
                </div>
            </div>


            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Краткое описание"
                        description="Здесь должен быть только текст, не более 1000 символов"
                        :invalid-feedback="veeErrors.first('description')"
                    >
                        <input class="form-control" type="text" v-model="discount.description"
                               v-validate="{ max:1000 }" name="description"  data-vv-as="'Краткое описание'">
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Подробное описание"
                        description="Здесь можно использовать HTML-тэги"
                    >
                        <textarea class="form-control" v-model="discount.content_html" placeholder="введите несколько строчек"></textarea>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <b-form-group
                        label="Порядок применения скидок"
                        description='Для каждого туриста и для каждого дня расчитываются  все применяемые для этого туриста в этот день скидки вида "фиксированная сумма" и "% скидки"
                            и выбирается наибольшее значение. Для туриста эта скидка суммируется за весь период. Скидка вида "кол-во дней"
                            расчитывается отдельно и ее значение сравнивается с суммой остальных скидок и выбирается максимальное из них.'
                    >
                    </b-form-group>
                </div>
            </div>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_hotel } from '@/functions/hotel';
    import { functions_discount } from '@/functions_discount';
    import { functions_room } from '@/functions_room';
    import { functions_program } from '@/functions/program.js';

    export default {
        name: 'DiscountEditDialog',
        mixins: [functions, functions_hotel, functions_room, functions_program, functions_discount],
        data: function () {
            return {
            };
        },
        model: {
            prop: "discount_id",
            event: "hide"
        },
        props: {
            discount_id: Number,
            all: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                let self = this;
                this.saveDiscount(function(self){
                    let hotelDiscount = self.findElementByID(self.discounts, self.discount.id);
                    console.log('handleOk hotelDiscount=',hotelDiscount);
                    if (self.is(hotelDiscount)) {
                        hotelDiscount.title = self.discount.title;
                        hotelDiscount.value_percent = self.discount.value_percent;
                        hotelDiscount.value_fixed = self.discount.value_fixed;
                        hotelDiscount.value_days = self.discount.value_days;
                        hotelDiscount.room_id = self.discount.room_id;
                        hotelDiscount.tarif_id = self.discount.tarif_id;
                        hotelDiscount.social = self.discount.social;
                        hotelDiscount.sex = self.discount.sex;
                        hotelDiscount.place_type = self.discount.place_type;
                        hotelDiscount.start_at = self.discount.start_at;
                        hotelDiscount.end_at = self.discount.end_at;
                        hotelDiscount.sale_start_at = self.discount.sale_start_at;
                        hotelDiscount.sale_end_at = self.discount.sale_end_at;
                        hotelDiscount.disabled_at  = self.discount.disabled_at;
                    }
                    self.$emit("changed", self.discount.id);
                    self.$emit("hide", 0);
                }, self);
            },
            onChangePercent : function () {
                if (this.discount.value_percent > 0)
                {
                    this.discount.value_fixed = 0;
                    this.discount.value_days = 0;
                }
            },
            onChangeFixed : function () {
                if (this.discount.value_fixed > 0)
                {
                    this.discount.value_percent = 0;
                    this.discount.value_days = 0;
                }
            },
            onChangeDays : function () {
                if (this.discount.value_days > 0)
                {
                    this.discount.value_fixed = 0;
                    this.discount.value_percent = 0;
                }
            },
        },
        computed: {
            _show_modal_local: {
                get: function () {
                    return !!this.discount_id
                },
                set: function (newValue) {}
            },

            _sale_start_at : {
                get: function () {
                    if (!this.is(this.discount.sale_start_at)) return null;
                    return new Date(this.discount.sale_start_at.slice(0, 10));
                },
                set: function (v) {
                    this.discount.sale_start_at = dateToISO(v);
                }
            },

            _sale_end_at : {
                get: function () {
                    if (!this.is(this.discount.sale_end_at)) return null;
                    return new Date(this.discount.sale_end_at.slice(0, 10));
                },
                set: function (v) {
                    this.discount.sale_end_at = dateToISO(v);
                }
            },

            _start_at : {
                get: function () {
                    if (!this.is(this.discount.start_at)) return null;
                    return new Date(this.discount.start_at.slice(0, 10));
                },
                set: function (v) {
                    this.discount.start_at = dateToISO(v);
                }
            },

            _end_at : {
                get: function () {
                    if (!this.is(this.discount.end_at)) return null;
                    return new Date(this.discount.end_at.slice(0, 10));
                },
                set: function (v) {
                    this.discount.end_at = dateToISO(v);
                }
            },
            _enabled: {
                get: function () {
                    return !this.is(this.discount.disabled_at);
                },
                set: function (v) {
                    if (v) {
                        this.discount.disabled_at = null;
                    }
                    else {
                        this.discount.disabled_at = dateTimeToISO(new Date());
                    }
                },
            },
            _no_combine: {
                get: function () {
                    return !!this.discount.no_combine;
                },
                set: function (v) {
                    this.discount.no_combine = !!v;
                },
            },
            _social: {
                get: function () {
                    return !!this.discount.social;
                },
                set: function (v) {
                    this.discount.social = !!v;
                },
            },

            _value_fixed:{
                get: function () {
                    return this.discount.value_fixed/100;
                },
                set: function (v) {
                    this.discount.value_fixed = Math.round(v*100);
                },
            }
        },
        created: function() {
            this.hotel = this.all.hotel;
            this.discounts = this.all.discounts;
            this.rooms = this.all.rooms;
            this.programs = this.all.programs;
            this.loadDiscount(this.discount_id);
        },

    }
</script>
